module.exports = __webpack_public_path__ + "media/payment_icons/mastercard-6208f97f.svg";